import { Spin, Table } from 'antd';
import moment from 'moment';
import React from 'react';
import './RefundsTable.scss';

const RefundsTable = ({
  data,
  current,
  totalCount,
  onPaginationChange,
  fetching,
  offset
}) => {
  const columnsCollection = {
    noIndex: {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, record, index) => {
        const label = <span>{offset + index + 1}</span>;
        return label;
      }
    },
    dateRefunded: {
      title: 'Refund Date',
      dataIndex: 'dateRefunded',
      key: 'dateRefunded',

      sorter: (a, b) =>
        moment(a?.dateRefunded).unix() - moment(b?.dateRefunded).unix(),
      render: (value, record) => {
        const dateObject = new Date(record.dateRefunded);
        const dateString = dateObject.toLocaleDateString();

        return <span>{dateString}</span>;
      }
    },
    datePurchased: {
      title: 'Purchase Date',
      dataIndex: 'datePurchased',
      key: 'datePurchased',
      sorter: (a, b) =>
        moment(a?.datePurchased).unix() - moment(b?.datePurchased).unix(),
      render: (value, record) => {
        const dateObject = new Date(record.datePurchased);
        const dateString = dateObject.toLocaleDateString();

        return <span>{dateString}</span>;
      }
    },
    refundPeriod: {
      title: 'Refund Period',
      dataIndex: 'refundPeriod',
      key: 'refundPeriod',
      render: (value, record) => {
        return <span>{record.refundPeriod}</span>;
      }
    },
    name: {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (value, record) => {
        return <span>{record.name}</span>;
      }
    },
    email: {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (value, record) => {
        return <span>{record.email}</span>;
      }
    },
    courseCode: {
      title: 'Course Code',
      dataIndex: 'courseCode',
      key: 'courseCode',
      render: (value, record) => {
        return <span>{record.courseCode}</span>;
      }
    },
    isPartial: {
      title: 'Is Partial',
      dataIndex: 'isPartial',
      key: 'isPartial',
      render: (value, record) => {
        return <span>{record.isPartial ? 'Yes' : 'No'}</span>;
      }
    },
    amount: {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (value, record) => {
        return <span>{record.amount}</span>;
      }
    },
    reason: {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
      render: (value, record) => {
        return <span>{record.reason}</span>;
      }
    }
  };

  const renderColumns = () => {
    const columns = [
      'noIndex',
      'dateRefunded',
      'datePurchased',
      'refundPeriod',
      'name',
      'email',
      'courseCode',
      'isPartial',
      'amount',
      'reason'
    ];
    return columns.map((item) => columnsCollection[item]);
  };
  return (
    <div>
      {fetching ? <Spin /> : null}
      {data.length > 0 ? (
        <div>
          <div>Total count: {totalCount}</div>
          <Table
            columns={renderColumns()}
            tableLayout="auto"
            dataSource={data}
            expandable={{ defaultExpandAllRows: true }}
            pagination={{
              current,
              total: totalCount,
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30']
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : null}
      {data.length === 0 && !fetching ? <div>No record found</div> : null}
    </div>
  );
};

export default RefundsTable;
